module.exports = __webpack_public_path__ + "media/images/social-share-button/google_bookmark-baf7fc3f2b1b2d21f7283f4823e72bda.svg";